var map = {
	"./AluK_BtoB_platform_Dutch": "8f73",
	"./AluK_BtoB_platform_Dutch.json": "8f73",
	"./AluK_BtoB_platform_English": "1338",
	"./AluK_BtoB_platform_English.json": "1338",
	"./AluK_BtoB_platform_EnglishFR": "c6be",
	"./AluK_BtoB_platform_EnglishFR.json": "c6be",
	"./AluK_BtoB_platform_French": "1068",
	"./AluK_BtoB_platform_French.json": "1068",
	"./AluK_BtoB_platform_FrenchBE": "6ca0",
	"./AluK_BtoB_platform_FrenchBE.json": "6ca0",
	"./AluK_BtoB_platform_Italian": "863b",
	"./AluK_BtoB_platform_Italian.json": "863b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28c9";